import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';

const JobResults = () => {
    const { id } = useParams(); // Get the job ID from the URL
    const [results, setResults] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        const fetchResults = async () => {
            try {
                // Replace with actual API endpoint for job results
                const response = await axios.get(`http://127.0.0.1:5000/jobs/${id}/results`);
                setResults(response.data);
                setLoading(false);
            } catch (err) {
                console.error('Error fetching job results:', err);
                setError('Failed to load results.');
                setLoading(false);
            }
        };

        fetchResults();
    }, [id]);

    if (loading) {
        return <p>Loading...</p>;
    }

    if (error) {
        return <p>{error}</p>;
    }

    return (
        <div style={{ padding: '20px' }}>
            <h2>Results for Job {id}</h2>
            <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: '20px', textAlign: 'left' }}>
                <thead>
                    <tr>
                        <th style={{ border: '1px solid #ddd', padding: '10px' }}>Anonymized Candidate Code</th>
                        <th style={{ border: '1px solid #ddd', padding: '10px' }}>Analytical</th>
                        <th style={{ border: '1px solid #ddd', padding: '10px' }}>Behavioural</th>
                        <th style={{ border: '1px solid #ddd', padding: '10px' }}>Situational & Job Simulation</th>
                        <th style={{ border: '1px solid #ddd', padding: '10px' }}>Predominant Emotional States</th>
                    </tr>
                </thead>
                <tbody>
                    {results.map((result, index) => (
                        <tr key={index}>
                            <td style={{ border: '1px solid #ddd', padding: '10px' }}>{result.candidateCode}</td>
                            <td style={{ border: '1px solid #ddd', padding: '10px' }}>{result.analytical}</td>
                            <td style={{ border: '1px solid #ddd', padding: '10px' }}>{result.behavioural}</td>
                            <td style={{ border: '1px solid #ddd', padding: '10px' }}>{result.situational}</td>
                            <td style={{ border: '1px solid #ddd', padding: '10px' }}>{result.emotionalStates}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default JobResults;
